<footer class="footer">
	<div class="footer-inner">
		<span>&copy; {{ year }} VMVT</span>
		<a href="mailto:okis@vmvt.lt">okis&#64;vmvt.lt</a>
		<span>v{{ version }}</span>
	</div>
</footer>
